$(function () {
  $("#tabs").tabs();
});

//MENU HOVER LIQUIFY
function formatPoints(points, close) {
  points = [...points];

  if (!Array.isArray(points[0])) {
    points = points.map(({ x, y }) => [x, y]);
  }

  if (close) {
    const lastPoint = points[points.length - 1];
    const secondToLastPoint = points[points.length - 2];

    const firstPoint = points[0];
    const secondPoint = points[1];

    points.unshift(lastPoint);
    points.unshift(secondToLastPoint);

    points.push(firstPoint);
    points.push(secondPoint);
  }

  return points.flat();
}

function spline(points = [], tension = 1, close = false, cb) {
  points = formatPoints(points, close);

  const size = points.length;
  const last = size - 4;

  const startPointX = close ? points[2] : points[0];
  const startPointY = close ? points[3] : points[1];

  let path = "M" + [startPointX, startPointY];

  cb && cb("MOVE", [startPointX, startPointY]);

  const startIteration = close ? 2 : 0;
  const maxIteration = close ? size - 4 : size - 2;
  const inc = 2;

  for (let i = startIteration; i < maxIteration; i += inc) {
    const x0 = i ? points[i - 2] : points[0];
    const y0 = i ? points[i - 1] : points[1];

    const x1 = points[i + 0];
    const y1 = points[i + 1];

    const x2 = points[i + 2];
    const y2 = points[i + 3];

    const x3 = i !== last ? points[i + 4] : x2;
    const y3 = i !== last ? points[i + 5] : y2;

    const cp1x = x1 + ((x2 - x0) / 6) * tension;
    const cp1y = y1 + ((y2 - y0) / 6) * tension;

    const cp2x = x2 - ((x3 - x1) / 6) * tension;
    const cp2y = y2 - ((y3 - y1) / 6) * tension;

    path += "C" + [cp1x, cp1y, cp2x, cp2y, x2, y2];

    cb && cb("CURVE", [cp1x, cp1y, cp2x, cp2y, x2, y2]);
  }

  return path;
}

function pointsInPath(path) {
  const pathLength = path.getTotalLength();
  const numPoints = 150;
  const step = pathLength / numPoints;
  const points = [];

  for (let i = 0; i < pathLength; i += step) {
    points.push(path.getPointAtLength(i));
  }

  return points;
}

function createCoordsTransformer(svg) {
  const pt = svg.createSVGPoint();

  return function (e) {
    pt.x = e.clientX;
    pt.y = e.clientY;

    return pt.matrixTransform(svg.getScreenCTM().inverse());
  };
}

const buttonPath = document.getElementById("btn-path");

function createLiquidPath(path, options) {
  const svgPoints = pointsInPath(path, options.detail);
  const originPoints = svgPoints.map(({ x, y }) => ({ x, y }));
  const liquidPoints = svgPoints.map(({ x, y }) => ({ x, y }));
  const mousePos = { x: 0, y: 0 };
  const transformCoords = createCoordsTransformer(path.closest("svg"));

  const pointDistance = Math.hypot(originPoints[0].x - originPoints[1].x, originPoints[0].y - originPoints[1].y);
  const maxDist = {
    x: options.axis.includes("x") ? pointDistance * 2 : 0,
    y: options.axis.includes("y") ? pointDistance * 2 : 0,
  };

  gsap.ticker.add(() => {
    gsap.set(path, {
      attr: {
        d: spline(liquidPoints, options.tension, options.close),
      },
    });
  });

  window.addEventListener("mousemove", (e) => {
    const { x, y } = transformCoords(e);

    mousePos.x = x;
    mousePos.y = y;

    liquidPoints.forEach((point, index) => {
      const pointOrigin = originPoints[index];
      const distX = Math.abs(pointOrigin.x - mousePos.x);
      const distY = Math.abs(pointOrigin.y - mousePos.y);

      if (distX <= options.range.x && distY <= options.range.y) {
        const difference = {
          x: pointOrigin.x - mousePos.x,
          y: pointOrigin.y - mousePos.y,
        };

        const target = {
          x: pointOrigin.x + difference.x,
          y: pointOrigin.y + difference.y,
        };

        const x = gsap.utils.clamp(pointOrigin.x - maxDist.x, pointOrigin.x + maxDist.x, target.x);

        const y = gsap.utils.clamp(pointOrigin.y - maxDist.y, pointOrigin.y + maxDist.y, target.y);

        gsap.to(point, {
          x: x,
          y: y,
          ease: "sine",
          overwrite: true,
          duration: 0.175,
          onComplete() {
            gsap.to(point, {
              x: pointOrigin.x,
              y: pointOrigin.y,
              ease: "elastic.out(1, 0.3)",
              duration: 2.25,
            });
          },
        });
      }
    });
  });
}

const prefersReducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

if (prefersReducedMotionQuery && !prefersReducedMotionQuery.matches) {
  createLiquidPath(buttonPath, {
    // detail: 33,
    // tension: 1,
    // close: true,
    // range: {
    //   x: 17,
    //   y: 8
    detail: 1000,
    tension: 1.2,
    close: true,
    range: {
      x: 250,
      y: 6,
    },
    axis: ["y"],
  });
}

//let animation = gsap.timeline({repeat:20})
//let targets = document.querySelectorAll(".demo div")
//let numberOfTargets = targets.length
//
//let duration = 0.4 //change this
//let pause = 0.75 // change this
//
//let stagger = duration + pause
//let repeatDelay = (stagger * (numberOfTargets - 1)) + pause
//
//function init() {
//  gsap.set(".demo", {autoAlpha:1})
//  animation.from(targets, {y:80, duration:duration, opacity:0, stagger:{
//    each:stagger,
//    repeat:-1,
//    repeatDelay:repeatDelay
//  }})
//     .to(targets, {y:-80, duration:duration, opacity:0, stagger:{
//    each:stagger,
//    repeat:-1,
//    repeatDelay:repeatDelay
//  }}, stagger)
//}
////click anywhere to pause
//init()

// if(jQuery('body').hasClass('template-index')) {

$(function () {
  //Walking characters
  if ($(".walking-container").length) {
    const cardsContainer = document.querySelector(".walking-container");

    cardsContainer.innerHTML += cardsContainer.innerHTML;

    const direction = cardsContainer.getAttribute("data-direction");
    const directionVal = direction == "rtl" ? "-" : "+";
    // console.log(directionVal + ' 222');

    const cards = gsap.utils.toArray(".walking-character");

    function setAnimValues() {
      const cardWidth = innerWidth / (cards.length / 2);

      cards.forEach((card, i) =>
        gsap.set(card, {
          x: () => i * cardWidth,
          overwrite: "auto",
        }),
      );

      gsap.to(cards, {
        duration: 20,
        ease: "none",
        x: directionVal + `=${innerWidth}`,
        repeat: -1,
        modifiers: {
          x: gsap.utils.unitize(gsap.utils.wrap(-cardWidth, innerWidth * 2 - cardWidth), "px"),
        },
      });
    }

    window.addEventListener("resize", setAnimValues);
    setAnimValues();
  }
});

// }

//FADE IN CONTENT ON SCROLL

const boxes = gsap.utils.toArray(".fadein");

boxes.forEach((box, i) => {
  const anim = gsap.fromTo(box, { autoAlpha: 0, y: 50 }, { duration: 1, autoAlpha: 1, y: 0 });
  ScrollTrigger.create({
    trigger: box,
    animation: anim,
    toggleActions: "play none none none",
    once: true,
  });
});

const homeintro = gsap.utils.toArray(".home-intro");
let badges = document.querySelectorAll(".badge");

homeintro.forEach((badge, i) => {
  const anim = gsap.fromTo(
    badges,
    { autoAlpha: 0, y: 50, stagger: { each: 0.3 } },
    { duration: 1, stagger: { each: 0.3 }, autoAlpha: 1, y: 0 },
  );
  ScrollTrigger.create({
    trigger: badge,
    animation: anim,
    toggleActions: "play none none none",
    once: true,
  });
});

//Add 'per pack' to Paywhirl Subsciptions discounted price
$(function () {
  $(".paywhirl-price").addClass("per-pack");
});

// Calculate total based upon Quantity and / or Subscription Discount
$(function () {
  function updateTotals() {
    const basePrice = $(".calculated-total").data("base-price");
    const discountedPrice = Math.round(basePrice * 0.9); // 10% discount
    const isDiscounted = !!$("input[type=radio][name=paywhirl-plan-selector-group]:checked").val(); //Create boolean check
    const quantity = $("input[type=number][name=quantity]").val();
    const calculatedTotal = quantity * (isDiscounted ? discountedPrice : basePrice);
    const formattedCalculatedTotal = (calculatedTotal / 100).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });

    $(".js-calculated-total").text(formattedCalculatedTotal);
  }

  updateTotals();

  $("input[type=radio][name=paywhirl-plan-selector-group]").on("change", updateTotals);

  $("input[type=number][name=quantity]").on("change", updateTotals);
});

$(function () {
  const stickers = $(".sticker");
  stickers.each(function () {
    const sticker = this;
    const container = $(this).closest(".sticker-container").get(0);

    //set sticker disappear at first
    gsap.set(sticker, { scale: 0, xPercent: -50, yPercent: -10 });
    //display sticker behind the scenes
    $(sticker).show();

    //on enter, make sticker big and opaque
    container.addEventListener("pointerenter", function (e) {
      gsap.to(sticker, 0.3, { scale: 1, opacity: 1 });
      positionSticker(e);
    });

    //on leave get sticker small/transparent
    container.addEventListener("pointerleave", function (e) {
      gsap.to(sticker, 0.3, { scale: 0, opacity: 0 });
      positionSticker(e);
    });

    //move sticker along
    container.addEventListener("pointermove", function (e) {
      positionSticker(e);
      //console.log('container entered');
    });

    const positionSticker = function (e) {
      // console.log('moving', $(sticker).parent().attr('class'))

      // const relX = e.pageX - getOffsetLeft(container);
      // const relY = e.pageY - getOffsetTop(container);

      const relX = e.pageX - $(container).offset().left;
      const relY = e.pageY - $(container).offset().top;

      // console.log('container: ', container, 'event', e);
      // console.log('e.pageX', e.pageX,  "e.pageY", e.pageY, "container.offsetLeft", container.offsetLeft, "container.offsetTop", container.offsetTop,'getOffsetTop(container)', getOffsetTop(container), '$(container).offset().top', $(container).offset().top,  'relX', relX, 'relY', relY );

      const old_relX = sticker.getAttribute("relX");

      sticker.setAttribute("relX", relX);

      if (relX - old_relX > 5) {
        //moving right. tilt clockwise
        gsap.to(sticker, {
          rotation: 12,
          duration: 0.3,
          ease: "none",
        });
      } else if (relX - old_relX < -5) {
        //moving left. tilt counterclockwise
        gsap.to(sticker, {
          rotation: -12,
          duration: 0.3,
          ease: "none",
        });
      } else {
        //upright
        gsap.to(sticker, {
          rotation: 0,
          duration: 0.3,
          ease: "none",
        });
      }

      gsap.to(sticker, { duration: 1.25, ease: "expo.out", x: relX, y: relY });
    };
  });

  $(".hero-slide-piano__content, .section-hero-slider-piano__paging")
    .on("mouseover", function () {
      $(this)
        .closest(".sticker-container")
        .find(".sticker")
        .each(function () {
          gsap.to(this, 0.3, { scale: 0, opacity: 0 });
        });
    })
    .on("mouseout", function () {
      $(this)
        .closest(".sticker-container")
        .find(".sticker")
        .each(function () {
          gsap.to(this, 0.3, { scale: 1, opacity: 1 });
        });
    });
});

// console.log(TweenLite.version)
// gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray(".full-width-image").forEach((section, i) => {
  // Skip if element has data-no-parallax attribute
  if (section.hasAttribute("data-no-parallax")) {
    return;
  }

  section.bg = section.querySelector("img");

  gsap.fromTo(
    section.bg,
    { y: 0 },
    {
      duration: 1,
      y: "30%",
      // backgroundPosition: () => `50% ${window.innerHeight * (1 - getRatio(section))}px`,
      ease: "none",
      scrollTrigger: {
        trigger: section,
        scrub: true,
        start: "top bottom",
        end: "bottom top",
        //markers: true,
        // invalidateOnRefresh: true // to make it responsive
      },
    },
  );
});

// Change cursor (PAW) State on Mousedown/up
// $('*').mousedown(function() {
//   // alert('clicked');
//   $('body').toggleClass('mouseDown');

// });

// $('*').mouseup(function() {
//   // alert('clicked');
//   $('body').toggleClass('mouseDown');
// });

//Main Heading Animations
// gsap.registerPlugin(SplitText);

// Store animation instances by section ID for proper cleanup
const textAnimations = {};

// Initialize text-in animation (generic for any section with .animate-text-in)
function initTextInAnimation(sectionElement) {
  const $section = $(sectionElement);
  const $headingElems = $section.find(".animate-text-in");

  if (!$headingElems.length) return;

  // Get the section ID from the shopify-section wrapper
  const sectionId = $section.closest(".shopify-section").attr("id");

  // Clean up any existing animation for this section
  if (sectionId && textAnimations[sectionId]) {
    cleanupTextInAnimation(sectionId);
  }

  $headingElems.css("visibility", "visible"); //Avoid first flash

  const headingSplitText = new SplitText($headingElems, { type: "words,chars" });
  const chars = headingSplitText.chars; //an array of all the divs that wrap each character

  gsap.set($headingElems, { perspective: 400 });

  const timeline = gsap.timeline();
  timeline.from(chars, {
    duration: 0.8,
    opacity: 0,
    scale: 0,
    y: 80,
    rotationX: 180,
    transformOrigin: "0% 50% -50",
    ease: "back",
    stagger: 2 / chars.length, // 2s to animate in
  });

  // Store references for cleanup
  if (sectionId) {
    textAnimations[sectionId] = {
      timeline: timeline,
      splitText: headingSplitText,
      elements: $headingElems,
    };
  }
}

// Cleanup function
function cleanupTextInAnimation(sectionId) {
  const animation = textAnimations[sectionId];
  if (!animation) return;

  // Kill the timeline
  if (animation.timeline) {
    animation.timeline.kill();
  }

  // Revert SplitText to original state
  if (animation.splitText) {
    animation.splitText.revert();
  }

  // Clear GSAP inline styles
  if (animation.elements) {
    gsap.set(animation.elements, { clearProps: "all" });
  }

  delete textAnimations[sectionId];
}

// Initialize on page load
$(function () {
  // Find all elements with .animate-text-in class
  $(".animate-text-in").each(function () {
    const section = $(this).closest(".shopify-section");
    if (section.length) {
      initTextInAnimation(section);
    }
  });
});

// Shopify theme editor support
document.addEventListener("shopify:section:load", function (event) {
  const hasAnimation = event.target.querySelector(".animate-text-in");
  if (hasAnimation) {
    // Small delay to ensure DOM is ready
    setTimeout(() => {
      initTextInAnimation(event.target);
    }, 50);
  }
});

document.addEventListener("shopify:section:unload", function (event) {
  cleanupTextInAnimation(event.target.id);
});

//Split link characters for dance animation
const danceContainers = $(
  ".hero-callouts .hero-callouts__button, .header__menu-item span, .banner__buttons a, .link-text, .footer-menu .link--text, .header__icons a.button, .product-grid-bordered .card-wrapper",
);
$(danceContainers).addClass("dance");

const danceElems = $(
  ".header__menu-item span, .hero-callouts__button span, .banner__buttons a, .link-text, .footer-menu .link--text, .header__icons a.button, .product-grid-bordered .card__heading a",
);
var linkSplitText = new SplitText(danceElems, { type: "chars", charsClass: "dance-char" });

$(function () {
  //Homepage only
  if ($("body").hasClass("template-index")) {
    var $win = $(window);

    $win.scroll(function () {
      if ($win.scrollTop() <= 50) {
        // Near the top
        $("body").removeClass("js-show-bottom-ticker");
      } else if ($win.height() + $win.scrollTop() >= $(document).height() - 100) {
        // Near the bottom
        $("body").removeClass("js-show-bottom-ticker");
      } else {
        // In between
        $("body").addClass("js-show-bottom-ticker");
      }
    });
  }
});

//Product Image SLider
$(function () {
  //Chack if it's on the page
  if ($(".carousel.product__image-slider").length) {
    var elem = document.querySelector(".carousel.product__image-slider");
    var flkty = new Flickity(elem, {
      contain: true,
      imagesLoaded: true,
      lazyLoad: 1,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: true,
      adaptiveHeight: true,
    });
    // var elemThumbnail = document.querySelector('.carousel.product__image-thumbnail');
    // var flktyB = new Flickity( elemThumbnail, {
    //   asNavFor: '.carousel.product__image-slider',
    //   contain: true,
    //   imagesLoaded: true,
    //   lazyLoad: 4,
    //   pageDots: false,
    //   prevNextButtons: false
    // });

    $(".product__image-slider, .product-icons").addClass("js-make-visible"); //Avoid first flash
  }
});

//Toggele Search Overlay
$(function () {
  $(".icon-search").click(function () {
    $("body").addClass("search-open");
  });

  $(".search-modal .icon-close").click(function () {
    $("body").removeClass("search-open");
  });

  $(".menu-hamburger").click(function () {
    $("body").toggleClass("js-mobile-nav-open");
  });
});

// Open external links in a new tab
// https://help.shopify.com/en/manual/online-store/themes/themes-by-shopify/vintage-themes/customizing-vintage-themes/open-external-links-in-new-tab
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = "_blank";
    links[i].rel = "noreferrer noopener";
  }
}
